import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { updateState } from '../../../redux/commonSlice';
import CustomButton from '../../../components/CustomButton';
import BrandboxOptions from '../../brandbox/components/BrandboxOptions';
import { updateReviewState } from '../../../redux/reviewSlice';

const BrandboxAssets = () => {

   const projectReducer = useSelector((state) => state.projectReducer);
   const reviewEventReducer = useSelector((state) => state.reviewEventReducer);
   const commonReducer = useSelector((state) => state.root.commonReducer);

   const [viewBrandbox, setViewBrandbox] = useState(false)
     const [expanded, setExpanded] = useState('');
   const dispatch = useDispatch()
      



  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
        // maxWidth: '800px',
        // margin: '0 auto',
        height: '93.5%',
        // border: '1px solid #ccc',
        padding: 4,
        backgroundColor:'#ffffff88',
        boxShadow:'0px 5px 15px #00000029', 
        borderRadius:'10px',
        mt:1
      }}
    >

        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            padding: 1,
            borderRadius: 1,
            height:'100%',
            width:'100%'
           
          }}
        >
          <Typography sx={{color:'#000000', fontFamily:'Rubik', fontWeight:600, fontSize:{xs:'16px',md:'18px',lg:'20px',xl:'30px'}}}>Brandbox</Typography>
          <Typography sx={{color:'#000000', fontFamily:'Rubik',  fontSize:{xs:'11px',md:'12px',lg:'13px',xl:'20px'}}}>Brand guidelines, color palette, and branded assets: find all your branded assets here!</Typography>
            <Box sx={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>
            
        {/* <Box  gap={{xs:0,md:1}} sx={{display:'flex', flexDirection:'column',  paddingTop:1, paddingBottom:2 }}>
           <Typography sx={{fontSize:{xs:'13px',sm:'14px',md:'14px',lg:'16px',xl:'20px'}, fontWeight:600, letterSpacing:0, fontFamily:'Rubik'}}>{`${projectReducer?.project_details?.name}`}</Typography>
           <Typography sx={{fontSize:{xs:'11px',md:'12px',lg:'13px',xl:'17px'}, display:'inline', textDecoration:'none', width:'100%', fontFamily:'Rubik', letterSpacing:'-0.05px'}}>{`${projectReducer?.project_details?.event_type?.name}`}</Typography>  
        </Box> */}
     
                        <Button 
                           variant="text"
                             color='secondary'
                             onClick={()=>dispatch(updateReviewState({view_brandbox_page:false}))}    
                           sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"},  fontFamily:'Rubik', textTransform:'none', letterSpacing:'0.65px', textDecoration:'underline'}}
                         >
                          Back to Video playback
                         </Button> 
            </Box>
                  {/* <Box> */}
                  
             <Box sx={{display:'flex', flexDirection:'column', height:'70%'}}>
                  {/* </Box> */}
              <BrandboxOptions setExpanded={setExpanded}  expanded={expanded}/>
            </Box>
        </Box>
    </Box>
  );
};

export default BrandboxAssets;
